import { Button, Divider, Group, Stack, Text, Title } from '@mantine/core';
import { IconExclamationMark } from '@tabler/icons-react';
import moment from 'moment';

import { CustomsStateNotificationType, Declaration, EORIGIN_DATE_FORMAT_WITH_TIME } from '@e-origin/shared';

import { useMarkCustomsNotificationAsRead } from '@hooks/declaration';

IconExclamationMark;
interface CustomsStateNotificationsProps {
  declaration: Declaration;
}

export const CustomsStateNotifications: React.FC<CustomsStateNotificationsProps> = ({ declaration }) => {
  const markNotificatonAsRead = useMarkCustomsNotificationAsRead();

  return (
    <>
      <Divider mb="md" />
      <Stack mt="md" mb="xl">
        {declaration.customsState.notifications.map((notification, index) => (
          <Group align="center" gap="xl" key={`customsStateNotification${index}`}>
            <Stack gap="sm">
              <Title size="lg" fw="bold">
                Notification
              </Title>
              <Text style={{ whiteSpace: 'pre-line' }}>{notification.message}</Text>
              <Text c="dimmed" fz="sm">
                {moment(notification.receivedAt ?? notification.createdAt).format(EORIGIN_DATE_FORMAT_WITH_TIME)}
              </Text>
            </Stack>
            <Stack>
              {!notification.read && (
                <IconExclamationMark
                  color={notification.notificationType === CustomsStateNotificationType.ACTION_PENDING ? 'red' : 'orange'}
                  size={40}
                  stroke={3}
                />
              )}
            </Stack>
            {notification.notificationType === CustomsStateNotificationType.NOTIFICATION_PENDING && (
              <Button
                size="md"
                onClick={() => markNotificatonAsRead.mutate({ declarationId: declaration._id, notificationId: notification._id })}
                disabled={notification.read}
              >
                {notification.read ? 'Read' : 'Mark as read'}
              </Button>
            )}
          </Group>
        ))}
      </Stack>
    </>
  );
};
